<template>
    <painel-component :itens="itensOne">
        <error-component :errors="errors" v-if="showError"/>
        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <form v-else>
            <row-component>
                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.name }">
                    <label>Nome:</label>
                    <input-component disabled :type-input="'text'" v-model="formDate.name"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <label>Status:</label>
                    <Multiselect disabled v-model="formDate.status" :searchable="true" :options="selectInput"
                                 :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.permissions }"
                                   v-for="(permission, index) in selectPage" :key="index">
                    <div class="form-check checkBoxHeader">
                        <input disabled class="form-check-input" type="checkbox" :value="index"
                               :id="'checkBoxMaster' + index" :name="index">
                        <label class="form-check-label">
                            {{ permission.label }}
                        </label>
                    </div>
                    <div class="form-check" v-for="(option, indexTwo) in permission.options" :key="indexTwo">
                        <input disabled type="checkbox" :value="option.value" :id="'checkOne' + option.value"
                               :class="'form-check-input checkBoxAll' + index">
                        <label class="form-check-label">
                            {{ option.label }}
                        </label>
                    </div>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                    <button-float class="w-100" :itens="itensTwo"/>
                </row-col-component>
            </row-component>
        </form>
    </painel-component>
</template>

<script>

import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import InputComponent from "@/components/form/InputComponent";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import Multiselect from "@vueform/multiselect";
import ErrorComponent from "@/components/alerts/ErrorComponent";
import LoderSendComponent from "@/components/LoderSendComponent";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "GroupUserShow",
    components: {
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        ButtonFloat,
        Multiselect,
        ErrorComponent,
        LoderSendComponent
    },

    props: {
        id: {
            required: true
        }
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Grupo de Usuário')
        this.showLoader = true
        this.loadPageItens()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Ver",
                icon: "eye"
            },

            itensTwo: {
                route: "/group-user/search",
                icon: "reply all",
                name: 'Voltar'
            },

            itensThree: {
                route: "/group-user/create",
                icon: "plus",
                name: 'Adicionar'
            },

            formDate: {
                name: '',
                status: '',
                permissions: [],
                _method: 'PUT'
            },

            errors: [],
            sendForm: false,
            showError: false,
            showLoader: false,
        }
    },

    methods: {
        scrollTop() {
            window.scrollTo(0, 0);
        },

        checkBoxCheckedStart() {
            let totalPage = 0;
            let cont = 0;
            let i = 0;
            let permissionsList = this.formDate.permissions;
            this.selectPage.forEach(function (element) {
                cont = 0;
                totalPage = element.options.length;

                element.options.forEach(function (item) {
                    if (permissionsList.includes(item.value)) {
                        document.getElementById("checkOne" + item.value).checked = true
                        cont = cont + 1;
                    }
                });
                if (cont >= totalPage) {
                    document.getElementById("checkBoxMaster" + i).checked = true
                }
                i = i + 1;
            });
        },

        loadPageItens() {
            this.$store.dispatch('loadSelectSearch', 'page');
            this.$store.dispatch('loadGroupUser', this.id).then((r) => {
                this.formDate = r;
                setTimeout(() => {
                    this.checkBoxCheckedStart()
                }, 1000)
            }).catch(() => {
                this.showLoader = false;
                toast.error("Erro desconhecido !", {timeout: 2000});
            })
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 1)
                .then((r) => {
                    if (r.data.indexOf('group-user-search') !== -1) {
                        this.showLoader = false;
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            });
        },
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.selectNotSearch
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactive;
        },

        selectPage() {
            return this.$store.state.var.selectSearch;
        }
    }
}
</script>